// import robulogo from 'assets/robu.jpg';
export const STORES = [
  {
    id: 'robu',
    name: 'Robu.in',
    logo: '',
    color: '#e53935',
    url: 'https://robu.in',
    searchUrl: 'https://robu.in/?s=',
    description: 'Arduino, Raspberry Pi & Robotics',
    tag: 'Robotics Hub',
  },
  {
    id: 'robocraze',
    name: 'RoboCraze',
    logo: '',
    color: '#1565c0',
    url: 'https://robocraze.com',
    searchUrl: 'https://robocraze.com/search?q=',
    description: 'DIY Electronics & Robotics Kits',
    tag: 'DIY Kits',
  },
  {
    id: 'quartz',
    name: 'Quartz Components',
    logo: '',
    color: '#6a1b9a',
    url: 'https://quartzcomponents.com',
    searchUrl: 'https://quartzcomponents.com/search?q=',
    description: 'Premium Electronic Components',
    tag: 'Premium Parts',
  },
  {
    id: 'electronicscomp',
    name: 'Electronics Comp',
    logo: '',
    color: '#f57f17',
    url: 'https://www.electronicscomp.com',
    searchUrl: 'https://www.electronicscomp.com/search?q=',
    description: 'Wide range of components',
    tag: 'Wide Range',
  },
  {
    id: 'evelta',
    name: 'Evelta',
    logo: '',
    color: '#00695c',
    url: 'https://evelta.com',
    searchUrl: 'https://evelta.com/search?q=',
    description: 'IoT & Embedded Systems',
    tag: 'IoT Focused',
  },
  {
    id: 'amazon',
    name: 'Amazon India',
    logo: '',
    color: '#ff9900',
    url: 'https://amazon.in',
    searchUrl: 'https://www.amazon.in/s?k=',
    description: 'Fast delivery, wide selection',
    tag: 'Fast Delivery',
  },
  {
    id: 'flipkart',
    name: 'Flipkart',
    logo: '',
    color: '#2874f0',
    url: 'https://flipkart.com',
    searchUrl: 'https://www.flipkart.com/search?q=',
    description: 'Best prices on electronics',
    tag: 'Best Prices',
  },
  {
    id: 'thingbits',
    name: 'ThingBits',
    logo: '',
    color: '#37474f',
    url: 'https://thingbits.net',
    searchUrl: 'https://thingbits.net/search?q=',
    description: 'Maker community favorite',
    tag: 'Maker Picks',
  },
];

export const STORE_MAP = Object.fromEntries(STORES.map(s => [s.id, s]));
